export const countryOption = [
    { label: 'Brazil', value: '1' },
    { label: 'Canada', value: '2' },
  ];
export const statusOption = [
    { label: 'Active', value: '1' },
    { label: 'Inactive', value: '2' },
  ];
export const statusOption2 = [
    { label: 'Completed', value: '1' },
    { label: 'Pending', value: '2' },
    { label: 'Failed', value: '3' },
  ];
export const cityOption = [
    { label: 'Rochester', value: '1' },
    { label: 'Wisbech', value: '2' },
    { label: 'Marlow', value: '3' },
];
export const stateOption = [
    { label: 'Newyork', value: '1' },
    { label: 'Fenland', value: '2' },
    { label: 'Wycombe', value: '3' },
];
export const serviceOption = [
    { label: 'Computer Repair', value: '1' },
    { label: 'Plumbing', value: '2' },
    { label: 'House Cleaning', value: '3' },
];
export const staffOption = [
    { label: 'Stephan Peralt', value: '1' },
    { label: 'Brian Villalobos', value: '2' },
];
export const staffIdOption = [
    { label: 'ST5246', value: '1' },
    { label: 'ST1269', value: '2' },
];
export const minsOption = [
    { label: '30 Mins', value: '1' },
    { label: '15 Mins', value: '2' },
];
export const numberOption = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
];
export const hrsOption = [
    { label: '1 Hr', value: '1' },
    { label: '2 Hr', value: '2' },
];
export const documentOption = [
    { label: 'Visa', value: '1' },
    { label: 'Passport', value: '2' },
];
export const transactionOption = [
    { label: 'TXID24081054', value: '1' },
    { label: 'TXID24081032', value: '2' },
];
export const customerOption = [
    { label: 'Lori Broaddus', value: '1' },
    { label: 'Anthony Lewis', value: '2' },
];
export const paymentOption = [
    { label: 'Paypal', value: '1' },
    { label: 'Payment', value: '2' },
];
export const percentageOption = [
    { label: '25%', value: '1' },
    { label: '50%', value: '2' },
];
export const offerOption = [
    { label: 'Fixed', value: '1' },
    { label: 'Percentage', value: '2' },
];
export const companyOption = [
    { label: 'Valentines', value: '1' },
    { label: 'Black Friday', value: '2' },
];
export const LanguageOption = [
    { label: 'Valentines', value: '1' },
    { label: 'Black Friday', value: '2' },
];
export const customerIdOption = [
    { label: 'CU0263', value: '1' },
    { label: 'CU3695', value: '2' },
];